import { AdSenseScripts } from '@/features/advertisement/components/adsense/AdSenseScripts'
import { AmazonTamScripts } from '@/features/advertisement/components/amazon-tam/amazonTamScripts'
import { BlockthroughScripts } from '@/features/advertisement/components/blockthrough/BlockthroughScripts'
import { GptScripts } from '@/features/advertisement/components/gpt/GptScripts'
import { PrebidScripts } from '@/features/advertisement/components/prebid/PrebidScripts'

type AdvertisingScriptsProps = {
  handleGptReady: () => void
}

/**
 * @deprecated It is only being used for SRP. Should be removed and utilize the AdWrapper as the other pages
 */
export const AdvertisingScripts = ({ handleGptReady }: AdvertisingScriptsProps) => {
  return (
    <>
      <GptScripts handleGptReady={handleGptReady} />

      <PrebidScripts />

      <AmazonTamScripts />

      <AdSenseScripts />

      <BlockthroughScripts />
    </>
  )
}
